module.exports = __webpack_public_path__ + "static/media/255626HD_v2_ATGAM-SP_MedEd.35bedf75.mp4";